import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

interface Respuestadehttp{
  status: string;
  resultadofinal: string;
}

@Injectable({
  providedIn: 'root'
})
export class ServiMailsService {

  

  infoparaelmail;

  dataParaPHP = {"parametro1":"","parametro2":"","parametro3":"","parametro4":{}};
 
  constructor(private http: HttpClient) { }

  mandamailproveedores(servicio,to, subject, body, datos){
    this.dataParaPHP.parametro1 = to;
    this.dataParaPHP.parametro2 = subject;
    this.dataParaPHP.parametro3 = body;
    this.dataParaPHP.parametro4 = datos; 

    this.httpPost(servicio, ()=>{
    
    });
  }


  httpPost(servicio, callback){

    

    if(servicio == 'creaproveedor'){
      //const req = this.http.post<Respuestadehttp>('https://gt-logis.com/gt-transport-api/api-crea-proveedor.php',this.dataParaPHP)
      const req = this.http.post<Respuestadehttp>('https://diavisual.com/gtrans-mail-api-temp/api-crea-proveedor.php',this.dataParaPHP)

      .subscribe(
        res => {
          console.log(res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           callback()
          }
          
        },
        err => {
          console.log("Error occured");
          callback()
        }
      );
    }else
    

    if(servicio == 'asignaproveedor'){
      
      //console.log(this.dataParaPHP.parametro1) 
      //console.log(this.dataParaPHP.parametro2)
      //console.log(this.dataParaPHP.parametro3)
      //console.log(this.dataParaPHP.parametro4)
      //console.log( JSON.stringify(this.dataParaPHP.parametro4) )

      console.log(this.dataParaPHP)

     //this.http.post<Respuestadehttp>('https://www.gt-logis.com/gt-transport-api/api-asigna-proveedor-dev.php',this.dataParaPHP)
     this.http.post<Respuestadehttp>('https://www.gt-logis.com/gt-transport-api/api-asigna-proveedor.php',this.dataParaPHP)
    // this.http.post<Respuestadehttp>('https://www.diavisual.com/gtrans-mail-api-temp/api-asigna-proveedor.php',this.dataParaPHP)
     
     .subscribe(
        res => {
          console.log(res)
          console.log("RES ----> "+res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           callback()
          }
          
        },
        err => {
          console.log(err)
          console.log("Error occured" + JSON.stringify(err) );
          callback()
        }
      );
    }else

  

    if(servicio == 'asignaproveedorCargaPeligrosa'){
      const req = this.http.post<Respuestadehttp>('https://gt-logis.com/gt-transport-api/api-asigna-proveedor-quimicos.php',this.dataParaPHP)
     //const req = this.http.post<Respuestadehttp>('https://diavisual.com/gtrans-mail-api-temp/api-asigna-proveedor-quimicos.php',this.dataParaPHP)
      

      .subscribe(
        res => {
          console.warn("RES ----> "+res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           callback()
          }
          
        },
        err => {

          console.log("Error occured" + JSON.stringify(err) );
          callback()
        }
      );
    }else


    if(servicio == 'asignaproveedorTarifaNoExisteCargaPeligrosa'){
      const req = this.http.post<Respuestadehttp>('https://gt-logis.com/gt-transport-api/api-asigna-proveedor-tarifanoexiste-quimicos.php',this.dataParaPHP)
      //const req = this.http.post<Respuestadehttp>('https://diavisual.com/gtrans-mail-api-temp/api-asigna-proveedor-tarifanoexiste-quimicos.php',this.dataParaPHP)
      .subscribe(
        res => {
          console.log(res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           callback()
          }
          
        },
        err => {
          console.log("Error occured");
          callback()
        }
      );
    }else

 
    if(servicio == 'asignaproveedorTarifaNoExiste'){
      const req = this.http.post<Respuestadehttp>('https://gt-logis.com/gt-transport-api/api-asigna-proveedor-tarifanoexiste.php',this.dataParaPHP)
      //const req = this.http.post<Respuestadehttp>('https://diavisual.com/gtrans-mail-api-temp/api-asigna-proveedor-tarifanoexiste.php',this.dataParaPHP)
      
      .subscribe(
        res => {
          console.log(res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           callback()
          }
          
        },
        err => {
          console.log("Error occured");
          callback()
        }
      );
    }else
    if(servicio == 'tarifanoexiste'){
      
      const req = this.http.post<Respuestadehttp>('https://gt-logis.com/gt-transport-api/api-tarifa-no-existe.php',this.dataParaPHP)
      //const req = this.http.post<Respuestadehttp>('https://diavisual.com/gtrans-mail-api-temp/api-tarifa-no-existe.php',this.dataParaPHP)
      
      .subscribe(
        res => {
          console.log(res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           callback()
          }
          
        },
        err => {
          console.log("Error occured");
          callback()
        }
      );
    }else
    
    if(servicio == "eliminapedido"){
      
      const req = this.http.post<Respuestadehttp>('https://gt-logis.com/gt-transport-api/api-cancela-pedido.php',this.dataParaPHP)
      //const req = this.http.post<Respuestadehttp>('https://diavisual.com/gtrans-mail-api-temp/api-cancela-pedido.php',this.dataParaPHP)
      
      .subscribe(
        res => {
          console.log(res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           callback()
          }
          
        },
        err => {
          console.log("Error occured");
          callback()
        }
      );
    }else
    
    if(servicio == "notificaVistoBueno"){
      
      const req = this.http.post<Respuestadehttp>('https://gt-logis.com/gt-transport-api/api-notifica-vistobueno.php',this.dataParaPHP)
      
      .subscribe(
        res => {
          console.log(res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           console.log(res.status);
           callback()
          }
          
        },
        err => {
          console.log("Error occured");
          callback()
        }
      );
    }else

   if(servicio == "notificaVistoBuenoOperaciones"){
      
      const req = this.http.post<Respuestadehttp>('https://gt-logis.com/gt-transport-api/api-notifica-vistobueno-operaciones.php',this.dataParaPHP)
      
      .subscribe(
        res => {
          console.log(res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           console.log(res.status);
           callback()
          }
          
        },
        err => {
          console.log("Error occured");
          callback()
        }
      );
    }   

      


    if(servicio == "conductoradicional"){
      
     const req = this.http.post<Respuestadehttp>('https://gt-logis.com/gt-transport-api/api-notifica-conductor-adicional.php',this.dataParaPHP)
      //const req = this.http.post<Respuestadehttp>('https://diavisual.com/gtrans-mail-api-temp/api-notifica-conductor-adicional.php',this.dataParaPHP)
      
      .subscribe(
        res => {
          console.log(res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           callback()
          }
          
        },
        err => {
          console.log("Error occured");
          callback()
        }
      );
    }

    
    console.log("enviar done");
}




}//fin de clase
